import React from 'react';

export const TermsConditionsCO = () => {
    const fullUrl = window.location.protocol + '//' + window.location.hostname
    const wwwUrl = 'www.'+window.location.hostname
    return (
        <div>
            <div className="container py-5">
                <div className="row">
                    <div className="col-12">
                        <p className="title text-center fw-bold">TÉRMINOS Y CONDICIONES INMOBILIARIAS ASOCIADAS IRIS (CO)</p>
                        <p>
                            <span className="text-decoration-underline">INFOCASAS LE DA LA BIENVENIDA Y LE INFORMA E INVITA A TENER PRESENTE, que:</span><br></br> <br />Los Términos “nosotros”, “nuestro”, “IC”, “INFOCASAS” se refieren a la sociedad responsable del servicio IRIS en Colombia. El término “Usted”, “Usuario” o “Inmobiliaria”, se refiere al operador inmobiliario que participe del servicio Iris <a href={fullUrl} target="_blank" rel="noreferrer">{fullUrl}</a>
                        </p>
                        <p>
                            INFOCASAS ha desarrollado un servicio llamado Iris, que tiene el objeto de proveer una amplia oferta de obra nueva, a todas las inmobiliarias donde se encuentre presente, para que puedan comercializar en un entorno claro, justo, y transparente.
                        </p>
                        <p>
                            <span className="fw-bold">1. Capacidad.</span><br />
                            La aceptación de estos términos y condiciones solo podrá efectuarse por personas con capacidad legal para contratar conforme a la legislación de la República de Colombia.
                        </p>
                        <p>
                            <span className="fw-bold">2. Registro.</span><br />
                            Es obligatorio completar todos los datos requeridos en el formulario de registro por el usuario. Los Usuarios garantizan y responden de la veracidad, exactitud, vigencia y autenticidad de los Datos Personales ingresados.
                        </p>
                        <p>
                            <span className="fw-bold">3. Tratamiento de datos personales.</span><br />
                            Los datos personales serán tratados conforme a la normativa colombiana aplicable, incluyendo la Ley 1581 de 2012 y sus decretos reglamentarios. El Usuario autoriza el tratamiento conforme a la Política de Privacidad disponible en {wwwUrl}.
                        </p>
                        <p>
                            <span className="fw-bold">4. Publicidad y Comisiones.</span><br />
                            La Inmobiliaria se compromete a respetar los materiales de venta y las políticas de precios, descuentos y comisiones informadas en la plataforma Iris para Colombia.
                        </p>
                        <p>
                            <span className="fw-bold">5. Independencia de las partes.</span><br />
                            Las Partes son independientes y no existe relación laboral ni societaria alguna por virtud de estos términos y condiciones.
                        </p>
                        <p>
                            <span className="fw-bold">6. Propiedad Intelectual.</span><br />
                            Los contenidos y signos distintivos de {wwwUrl} son de propiedad de INFOCASAS o de terceros licenciantes y están protegidos por las normas aplicables en Colombia.
                        </p>
                        <p>
                            <span className="fw-bold">7. Modificación de Términos y Condiciones.</span><br />
                            INFOCASAS podrá modificar estos Términos y Condiciones en cualquier momento publicando la versión actualizada en el sitio. La continuidad en el uso del servicio implica aceptación.
                        </p>
                        <p>
                            <span className="fw-bold">8. Jurisdicción y Ley Aplicable.</span><br />
                            Estos términos se rigen por las leyes de la República de Colombia. Cualquier controversia será sometida a los jueces de la ciudad de Bogotá D.C.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}


